import React from "react";
import "./index.css";
import iconsList from "./icons"
import IconClose from "../IconClose";

const imageLocation = imagename => `/images/${imagename}.svg`;

/*
          lucket={props.lucket} 
          setEditing={props.setEditing}
*/

const LucketIcons = (props) => {
    return <div className="LucketIconsContainer">
        <div className="LucketIconsClose">
            <IconClose edit={() => props.setEditing(false)} justifyRight />
        </div>
        {iconsList.map(o => (
            <img
                className="LucketIcon"
                src={imageLocation(o)}
                alt={o}
                title={o}
                onClick={() => {
                    props.updateLucket(o + ".svg", "icon");
                    props.setEditing(false);
                }}
            />
        ))}
    </div>

        ;
};

export default LucketIcons;
